export default __webpack_public_path__ + "static/IBMPlexSans-Regular-Latin2-9340a047e2c400a8eff4a0543e6a666b.woff";